import { Dispatch, FC, SetStateAction } from "react";
import useInbox from "hooks/useInbox.ts";
import Icon from "components/Elements/Icon/Icon";
import { useContent } from "contexts/contentContext/contentContext.js";
//@ts-ignore
import useInboxQueryParams from "hooks/useInboxQueryParams.ts";
import MailActionsComponent from "../../Reusable/MailActionsComponent.js";
import { useAppSelector } from "../../../../../store/hooks.ts";
import { selectTParam } from "../../../../../store/selectors/inboxSelectors.ts";

interface TabBarMenuI {
  selectedTab: string;
  setSelectedTab: Dispatch<SetStateAction<string>>;
}

const tabs = [
  { name: "tab-info", iconName: "info" },
  // { name: "tab-activity", iconName: "activity" },
  // { name: "tab-comments", iconName: "comment-solid" },
  { name: "tab-share", iconName: "share-solid" },
];

const TabBarMenu: FC<TabBarMenuI> = (props) => {
  const { selectedTab, setSelectedTab } = props;
  const { getSelectedMail } = useInbox();
  const { getTextByKey } = useContent();
  const pageType = useAppSelector(selectTParam);

  const { getQueryParam } = useInboxQueryParams();

  const tabsToShow =
    getSelectedMail()?.security?.isSharingDisabled &&
    pageType === "received"
      ? tabs.filter((tab) => tab.name !== "tab-share")
      : tabs;

  return (
    <div className="mail-split-tab-bar">
      <ul className="mail-split-tab-bar-list">
        {tabsToShow?.map((tab, i) => (
          <li
            key={tab.name}
            className={tab.name === selectedTab ? "selected-tab" : ""}
            onClick={() => setSelectedTab(tab.name)}
          >
            <div className="icon-wrapper">
              <Icon
                name={tab.iconName}
                iconClass={selectedTab === tab.name ? "icon-selected" : "icon"}
                large
              />
              {tab.name === "tab-comments" &&
                getSelectedMail()?.commentsQuantity !== 0 && (
                  <span className="comments-quantity">
                    {getSelectedMail()?.commentsQuantity}
                  </span>
                )}
            </div>
            <span className="tab-name">{getTextByKey(tab.name)}</span>
          </li>
        ))}
      </ul>
      <div className="mail-split-action-list-wrapper">
          <MailActionsComponent
            mailData={getSelectedMail()}
            listItemRef={{
              current: document.getElementById("inbox-list-mail"),
            }}
            all={getQueryParam("t") === "all"}
            asIcons={false}
            isFirstElementForProductTour={false}
          />
      </div>
    </div>
  );
};
export default TabBarMenu;
